import { IconArrowInbox } from 'central-icons/IconArrowInbox';

import { MenuItem, RevelioTooltip } from '@revelio/ui';

import { downloadData } from '../Chart/chart-menu/data-download/download-plot-data';
import { useFileName } from '../Chart/utils/useFileName';
import { useTableRows } from '../TableSelectionProvider/TableSelectionProvider';
import { buildPostingXlsxRows } from './PostingDiscoverySelectedDataExportMenuItem';

export const PostingDiscoveryDataExportMenuItem = () => {
  const { allRows } = useTableRows();
  const fileName = useFileName({});
  const isDisabled = allRows.length === 0;

  const triggerDownload = () => {
    if (allRows.length === 0) return;
    downloadData(buildPostingXlsxRows(allRows), fileName);
  };

  const menuItem = (
    <MenuItem
      icon={<IconArrowInbox size={16} />}
      onClick={triggerDownload}
      disabled={isDisabled}
    >
      Download All
    </MenuItem>
  );

  if (!isDisabled) return menuItem;

  return (
    <RevelioTooltip
      label="Apply filters to load postings before downloading"
      placement="bottom"
    >
      <span>{menuItem}</span>
    </RevelioTooltip>
  );
};
